// extracted by mini-css-extract-plugin
export default {"editableCell__textarea":"styles_editableCell__textarea__UVXRm","editableCell__readonly":"styles_editableCell__readonly__YsCww"};